export function resolvePublicEnvValue(value: string = "") {
  if (["false", "true"].includes(value)) {
    return value === "true";
  }
  return value;
}
